import React from 'react';
import Header from '../landing_page/header';
import Footer from '../landing_page/footer';
import './About.css';

function About() {
  return (
    <>
    <Header />
    <div className='page1-body'>
        <h1>Coming Soon!</h1>
    </div>
    <Footer />
    </>
  )
}

export default About